<template>
    <b-row>
        <div class="d-flex mt-3">
            <img src="../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol">
            <h6 class="bold-heading mt6 ms-1">{{ $t('MemberDetails.title') }}</h6>
        </div>
    </b-row>
    <!-- {{ dataObj }} -->
    <b-row class="my-2 ps-3">
        <b-col sm="10" md="10" lg="10">
            <div v-if="status == '0'">
                <b-row>
                    <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                        <label class="display-field-label">{{ $t('MemberDetails.storemanagername') }}</label>
                    </b-col>
                    <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                        <p class="details-black-field">MR.Srinivasan Varadhan</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                        <label class="display-field-label">{{ $t('MemberDetails.lastrequest') }}</label>
                    </b-col>
                    <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                        <p class="details-black-field">07 DEC 2022 | 07:54 PM</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                        <label class="display-field-label">{{ $t('MemberDetails.email') }}</label>
                    </b-col>
                    <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                        <p class="details-black-field">asdf@gmail.com</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                        <label class="display-field-label">{{ $t('MemberDetails.phone') }}</label>
                    </b-col>
                    <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                        <p class="details-black-field">+91 9876543210</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                        <label class="display-field-label">{{ $t('MemberDetails.remark') }}</label>
                    </b-col>
                    <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                        <p class="details-description details-black-field">The Main Store of the hospital is managed by
                            Mr. Alex who is
                            responsible for
                            handling all medical equipment and
                            supplies. The store is well stocked with the latest and best medical equipment, ranging
                            from
                            the most
                            advanced medical
                            machines to the most basic tools and supplies.</p>
                    </b-col>
                </b-row>
            </div>
            <div v-else-if="status == '1'">
                <!-- <b-row>
                    <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                        <label class="display-field-label">{{ $t('MemberDetails.suppliercategory') }}</label>
                    </b-col>
                    <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                        <p class="details-black-field">{{ dataObj }}</p>
                    </b-col>
                </b-row> -->
                <b-row>
                    <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                        <label class="display-field-label">{{ $t('MemberDetails.associatedSince') }}</label>
                    </b-col>
                    <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                        <p class="details-black-field"> {{ dataObj.CreatedAt }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                        <label class="display-field-label">{{ $t('MemberDetails.address') }}</label>
                    </b-col>
                    <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                        <p class="details-black-field">{{ dataObj.Address }} - {{ dataObj.Pin }}
                        </p>
                        <!-- <p class="txt-blue">+ Add New Address</p> -->
                    </b-col>
                </b-row>
            </div>
        </b-col>
    </b-row>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
    props: {
        status: {
            type: String,
            default: ''
        },
        dataObj: {
            type: Object,
            default: {}
        }
    },
    setup() {
        return {

        }
    }

})
</script>

<style lang="scss">
.details-description {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    line-height: 25px;
}

.details-outercircle {
    border-radius: 20px;
    background-color: #FEECDE;
    min-width: 300px;
    width: auto;
    padding-left: 4px;
    padding-right: 9px;
    padding-bottom: 9px;
    padding-top: 9px;
    margin-right: 20px;
}

.main-store {
    font-size: 10px;
    border-radius: 50%;
    background-color: #CDD0FB;
    padding: 5px;
    margin-right: 10px;
}

.sub-store {
    background-color: #fff3cc;
    font-size: 10px;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
}

.dept-store {
    background-color: #f3b7c7;
    font-size: 10px;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
}
</style>